module.exports = __webpack_public_path__ + "img/pic_04.3f7db801.svg";